export enum SegmentIcon {
  start = 'start',
  end = 'end',
  stop = 'stop',
}

export enum SegmentWidth {
  Thin = 'thin',
  Thick = 'thick',
  Dynamic = 'dynamic',
}

export enum SegmentVariant {
  Standard = 'standard',
  Primary = 'primary',
}

export interface Segment {
  hide?: boolean;
  variant: SegmentVariant;
  icon?: SegmentIcon;
}
